import { makeStyles } from '@mui/styles'

export default makeStyles((theme) => ({
  labelAdornment: {
    '& label': {
      paddingRight: theme.spacing(3),
    },
  },
}))
